import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Checkbox } from "antd";
import { RootState } from "reducers/rootReducer";

const TaskInput: React.FC<any> = ({ value = undefined, onChange }) => {
  const [tasks, setTasks] = useState([]);
  const [values, setValues] = useState([]);
  const { projects, project } = useSelector((state: RootState) => state.auth);

  useEffect(() => {
    if (project) {
      const tasks = projects?.tasks?.[0]?.[0] || {};
      const selectedProject = projects?.projects.find((prj) => {
        return prj.id === project;
      });
      const selectedTaskId = Object.keys(tasks)?.find((taskId) => {
        return selectedProject?.taskId === taskId;
      });
      const projectSubTasks = tasks?.[selectedTaskId]?.subTasks ?? {};
      setTasks(
        Object.keys(projectSubTasks).map((subKey) => {
          return {
            id: subKey,
            ...projectSubTasks[subKey],
          };
        })
      );
      setValues([]);
    }
  }, [project]);

  return (
    <Checkbox.Group
      className="d-flex flex-column"
      value={values}
      onChange={(values) => {
        setValues(values);
        const results = values.map((id) => {
          return tasks.find((x) => {
            return x.id === id;
          });
        });
        onChange({
          type: "task-picker",
          tasks: results,
        });
      }}
    >
      {tasks.map((task, index) => (
        <Row className="mb-2" key={index} style={{ width: "100%" }}>
          <Col span={22} className="pr-2 d-flex">
            <span className="col-label">{task.name}</span>
          </Col>
          <Col span={2} className="pr-2 d-flex justify-content-end">
            <Checkbox className="mb-2 ml-0" value={task.id} />
          </Col>
        </Row>
      ))}
    </Checkbox.Group>
  );
};

export default TaskInput;
